import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { globals } from 'src/app/globals';
import { ToastService } from '../../services/toast.service';
import { userService } from '../../services/user.service';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnInit {

  user: any = {};
  dashboard: any = {};
  chartValue = false;
  areas: any = {};
  projects: any = {};
  showNotifications = false;
  notifications: any;
  notificationsCount: any = 0;

  gaugeLeft : EChartsOption = {
    series: [
      {
        type: 'gauge',
        startAngle: 200,
        endAngle: -20,
        max: 355,
        itemStyle: {
          color: '#6987c9'
        },
        pointer: {
          show: false
        },
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
          itemStyle: {
            borderWidth: 1,
            borderColor: '#6987c9'
          }
        },
        axisLine: {
          roundCap: true,
          lineStyle: {
            width: 10
          }
        },
        splitLine: {
          show: false,
          distance: 0,
          length: 10
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false,
          distance: 50
        },
        data: [],
        title: {
          fontSize: 14
        },
        detail: {
          width: 45,
          height: 14,
          fontSize: 30,
          color: '#000',
          borderColor: 'auto',
          borderRadius: 10,
          borderWidth: 0,
          formatter: '{value}'
        }
      }
    ]
  };

  gaugeMiddle : EChartsOption = {
    series: [
      {
        type: 'gauge',
        startAngle: 200,
        endAngle: -20,
        colorBy: 'data',
        max: 109,
        pointer: {
          show: false
        },
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
          itemStyle: {
            borderWidth: 0,
          }
        },
        axisLine: {
          roundCap: true,
          lineStyle: {
            width: 20
          }
        },
        splitLine: {
          show: false,
          distance: 0,
          length: 10
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false,
          distance: 50
        },
        data: [],
        title: {
          fontSize: 14
        },
        detail: {
          width: 45,
          height: 14,
          fontSize: 20,
          borderColor: 'auto',
          borderRadius: 10,
          borderWidth: 0,
          formatter: '{value}'
        }
      }
    ]
  };

  gaugeRight : EChartsOption = {
    series: [
      {
        type: 'gauge',
        startAngle: 200,
        endAngle: -20,
        max: 50000,
        itemStyle: {
          color: '#6987c9'
        },
        pointer: {
          show: false
        },
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
          itemStyle: {
            borderWidth: 1,
            borderColor: '#6987c9'
          }
        },
        axisLine: {
          roundCap: true,
          lineStyle: {
            width: 10
          }
        },
        splitLine: {
          show: false,
          distance: 0,
          length: 10
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false,
          distance: 50
        },
        data: [],
        title: {
          fontSize: 18
        },
        detail: {
          width: 45,
          height: 14,
          fontSize: 30,
          color: '#000',
          borderColor: 'auto',
          borderRadius: 10,
          borderWidth: 0,
          // formatter: '£{value}',
          formatter: function(value){
            let label = value
            return '£' + label.toLocaleString()
         }
        }
      }
    ]
  };

  chart : EChartsOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['Black Country', 'Cov & Warw', 'D2N2', 'GBS', 'Greater Lincs', 'LLEP', 'SEMLEP', 'Stoke & Staff']
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: 'Grant Contracted',
            type: 'bar',
            stack: 'main',
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: 'rgba(0,128,0,0.7)'
            },
            data: []
          },
          {
            name: 'Grant Contracting',
            type: 'bar',
            stack: 'main',
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: 'rgba(255, 206, 48, 0.7)'
            },
            data: []
          },
          {
            name: 'Grants In Pipeline',
            type: 'bar',
            stack: 'main',
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: 'rgba(255,165,0,0.7)'
            },
            data: []
          },
          {
            name: 'Prospect Grants',
            type: 'bar',
            stack: 'main',
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: 'rgba(105,135,201,0.7)'
            },
            data: []
          },
          {
            name: 'Grant Fund Remaining',
            type: 'bar',
            stack: 'main',
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: 'rgba(255,0,0,0.7)'
            },
            data: []
          }
        ]
  }

  changeValue() {
    // pound value
    if (this.user.graphValue) {
      this.user.graphValue = false;
      this.toastService.showToast({ header: 'Success', message: 'Graph data set to monetary value' });
    }
    // percentage
    else {
      this.user.graphValue = true;
      this.toastService.showToast({ header: 'Success', message: 'Graph data set to percentage value' });
    }
    this.updateDashboard();
  }

  constructor(
    public userService: userService, 
    private router: Router,
    private toastService: ToastService,
    private http: HttpClient
  ) { }

  getDashboard() {

    if (!this.user.selectedArea) {
      this.user.selectedArea = 0;
    }
    if (!this.user.selectedProject) {
      this.user.selectedProject = 1;
    }

    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'getDashboard')

    const body = {
      id: this.user.id,
      cid: this.user.cid,
      sid: this.user.sid,
      area: this.user.selectedArea,
      project: this.user.selectedProject
    };

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true) {
            this.dashboard = response.body;

            this.gaugeLeft.series[0].data.push({
              value: this.dashboard.companiesEnrolled,
              name: 'Companies Enrolled',
              detail: {
                valueAnimation: true,
                offsetCenter: ['0%', '-10%']
              },
              title: {
                offsetCenter: ['0%', '30%']
              }
            });

            this.gaugeMiddle.series[0].data.push({
              value: this.dashboard.liveProjects ?? 0,
              name: 'Live Projects',
              itemStyle: {
                color: '#6987c9',
              },
              detail: {
                valueAnimation: true,
                offsetCenter: ['0%', '-50%'],
                color: '#6987c9',
              },
              title: {
                offsetCenter: ['0%', '-25%'],
                color: '#6987c9',
              }
            },
            {
              value: this.dashboard.completedProjects ?? 0,
              name: 'Completed Projects',
              itemStyle: {
                color: 'green',
              },
              detail: {
                valueAnimation: true,
                offsetCenter: ['0%', '10%'],
                color: 'green',
              },
              title: {
                offsetCenter: ['0%', '35%'],
                color: 'green',
              },
            });

            if (this.dashboard.averageGrant == 'nan') {
              this.dashboard.averageGrant = 0;
            }
            this.gaugeRight.series[0].data.push ({
              value: this.dashboard.averageGrant,
              name: 'Grant Size',
              detail: {
                valueAnimation: true,
                offsetCenter: ['0%', '-10%'] // -15%
              },
              title: {
                offsetCenter: ['0%', '30%'] // -30%
              }
            })

            // false = %
            if (this.user.graphValue == true) {
              // Grant contracted
              this.chart.series[0].data.push(
                this.dashboard.areas[0].contractedValue,
                this.dashboard.areas[1].contractedValue, 
                this.dashboard.areas[2].contractedValue, 
                this.dashboard.areas[3].contractedValue, 
                this.dashboard.areas[4].contractedValue, 
                this.dashboard.areas[5].contractedValue, 
                this.dashboard.areas[6].contractedValue, 
                this.dashboard.areas[7].contractedValue
              );
              // Grant contracting
              this.chart.series[1].data.push(
                this.dashboard.areas[0].contractingValue,
                this.dashboard.areas[1].contractingValue, 
                this.dashboard.areas[2].contractingValue, 
                this.dashboard.areas[3].contractingValue, 
                this.dashboard.areas[4].contractingValue, 
                this.dashboard.areas[5].contractingValue, 
                this.dashboard.areas[6].contractingValue, 
                this.dashboard.areas[7].contractingValue
              );
              // Grant in pipeline
              this.chart.series[2].data.push(
                this.dashboard.areas[0].pipelineValue,
                this.dashboard.areas[1].pipelineValue, 
                this.dashboard.areas[2].pipelineValue, 
                this.dashboard.areas[3].pipelineValue, 
                this.dashboard.areas[4].pipelineValue, 
                this.dashboard.areas[5].pipelineValue, 
                this.dashboard.areas[6].pipelineValue, 
                this.dashboard.areas[7].pipelineValue
              );
              // Prospect grants
              this.chart.series[3].data.push(
                this.dashboard.areas[0].prospectValue,
                this.dashboard.areas[1].prospectValue, 
                this.dashboard.areas[2].prospectValue, 
                this.dashboard.areas[3].prospectValue, 
                this.dashboard.areas[4].prospectValue, 
                this.dashboard.areas[5].prospectValue, 
                this.dashboard.areas[6].prospectValue, 
                this.dashboard.areas[7].prospectValue
              );
              // Grant fund remaining
              this.chart.series[4].data.push(
                this.dashboard.areas[0].remainingValue,
                this.dashboard.areas[1].remainingValue, 
                this.dashboard.areas[2].remainingValue, 
                this.dashboard.areas[3].remainingValue, 
                this.dashboard.areas[4].remainingValue, 
                this.dashboard.areas[5].remainingValue, 
                this.dashboard.areas[6].remainingValue, 
                this.dashboard.areas[7].remainingValue
              );
            }
            else {
              // Grant contracted
              this.chart.series[0].data.push(
                this.dashboard.areas[0].contractedPercentage,
                this.dashboard.areas[1].contractedPercentage, 
                this.dashboard.areas[2].contractedPercentage, 
                this.dashboard.areas[3].contractedPercentage, 
                this.dashboard.areas[4].contractedPercentage, 
                this.dashboard.areas[5].contractedPercentage, 
                this.dashboard.areas[6].contractedPercentage, 
                this.dashboard.areas[7].contractedPercentage
              );
              // Grant contracting
              this.chart.series[1].data.push(
                this.dashboard.areas[0].contractingPercentage,
                this.dashboard.areas[1].contractingPercentage, 
                this.dashboard.areas[2].contractingPercentage, 
                this.dashboard.areas[3].contractingPercentage, 
                this.dashboard.areas[4].contractingPercentage, 
                this.dashboard.areas[5].contractingPercentage, 
                this.dashboard.areas[6].contractingPercentage, 
                this.dashboard.areas[7].contractingPercentage
              );
              // Grant in pipeline
              this.chart.series[2].data.push(
                this.dashboard.areas[0].pipelinePercentage,
                this.dashboard.areas[1].pipelinePercentage, 
                this.dashboard.areas[2].pipelinePercentage, 
                this.dashboard.areas[3].pipelinePercentage, 
                this.dashboard.areas[4].pipelinePercentage, 
                this.dashboard.areas[5].pipelinePercentage, 
                this.dashboard.areas[6].pipelinePercentage, 
                this.dashboard.areas[7].pipelinePercentage
              );
              // Prospect grants
              this.chart.series[3].data.push(
                this.dashboard.areas[0].prospectPercentage,
                this.dashboard.areas[1].prospectPercentage, 
                this.dashboard.areas[2].prospectPercentage, 
                this.dashboard.areas[3].prospectPercentage, 
                this.dashboard.areas[4].prospectPercentage, 
                this.dashboard.areas[5].prospectPercentage, 
                this.dashboard.areas[6].prospectPercentage, 
                this.dashboard.areas[7].prospectPercentage
              );
              // Grant fund remaining
              this.chart.series[4].data.push(
                this.dashboard.areas[0].remainingPercentage,
                this.dashboard.areas[1].remainingPercentage, 
                this.dashboard.areas[2].remainingPercentage, 
                this.dashboard.areas[3].remainingPercentage, 
                this.dashboard.areas[4].remainingPercentage, 
                this.dashboard.areas[5].remainingPercentage, 
                this.dashboard.areas[6].remainingPercentage, 
                this.dashboard.areas[7].remainingPercentage
              );
            }
            this.calculateTotals();
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting dashboard data' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting dashboard data' });
        }
      );
    
  }

  calculateTotals() {
    this.dashboard.availableTotal = 0;
    this.dashboard.contractingTotal = 0;
    this.dashboard.contractedTotal = 0;
    this.dashboard.pipelineTotal = 0;
    this.dashboard.prospectTotal = 0;
    this.dashboard.remainingTotal = 0;
    for (var i = 0; i < this.dashboard.areas.length; i++) {
      this.dashboard.availableTotal += parseFloat(this.dashboard.areas[i].available);
      this.dashboard.contractingTotal += parseFloat(this.dashboard.areas[i].contractingValue);
      this.dashboard.contractedTotal += parseFloat(this.dashboard.areas[i].contractedValue);
      this.dashboard.pipelineTotal += parseFloat(this.dashboard.areas[i].pipelineValue);
      this.dashboard.prospectTotal += parseFloat(this.dashboard.areas[i].prospectValue);
      this.dashboard.remainingTotal += parseFloat(this.dashboard.areas[i].remainingValue);
    }
  }

  updateDashboard() {
    this.userService.setData(this.user);
    if (window.location.hostname == 'aup.my-runway.co.uk') {
      window.location.href = 'https://aup.my-runway.co.uk/';
    } 
    else if (window.location.hostname == 'localhost') {
      window.location.href = window.location.href;
    }
    else {                
      window.location.href = 'https://my-runway.co.uk/';
    }
  }

  getAreas() {

    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'getAreas')

    const body = this.user;

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true && response.body.dataArray) {
            this.areas = response.body.dataArray;
            this.areas.push({
              id: 0,
              name: 'All Areas'
            })
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting area data' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting area data' });
        }
      );
    
  }

  getProjects() {

    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'getProjects')

    const body = this.user;

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true && response.body.dataArray) {
            this.projects = response.body.dataArray;
            this.projects.push({
              id: 0,
              name: 'All Projects'
            })
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting area data' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting area data' });
        }
      );
    
  }

  viewNotifications() {
    this.showNotifications = !this.showNotifications;
    if (this.showNotifications) {
      this.getNotifications();
    }
  }

  getNotifications() {

    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'getNotifications')

    const body = this.user;

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true) {
            this.notifications = response.body.dataArray;
            this.notificationsCount = response.body.count;
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting notification data' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting notification data' });
        }
      );
    
  }

  ngOnInit() {
    this.user = this.userService.getData();
    this.getDashboard();
    this.getProjects();
    this.getAreas();
    this.getNotifications();
  }

}